import { render, staticRenderFns } from "./EModalHistoricoTurma.vue?vue&type=template&id=68b8ce46&scoped=true"
import script from "./EModalHistoricoTurma.vue?vue&type=script&lang=js"
export * from "./EModalHistoricoTurma.vue?vue&type=script&lang=js"
import style0 from "./EModalHistoricoTurma.vue?vue&type=style&index=0&id=68b8ce46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b8ce46",
  null
  
)

export default component.exports